import { sort } from "@common/lib/array";
import { type KnowledgeBase } from "../types";

export type CategoryEx = KnowledgeBase.Api.ArticleCategory & {
  categories: CategoryEx[];
};
export const mapCategory = (
  categories: KnowledgeBase.Api.ArticleCategory[],
  category: KnowledgeBase.Api.ArticleCategory
): CategoryEx => ({
  ...category,
  categories: sort(
    categories.filter((x) => x.parentArticleCategoryId === category.articleCategoryId),
    { key: "sortOrder" }
  ).map((x) => mapCategory(categories, x))
});
